import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { CookieConsent } from "@/components/CookieConsent";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import LinkDetail from "@/pages/LinkDetail";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import Redirector from "@/pages/Redirector";
import About from "@/pages/About";
import AdminReserved from "@/pages/AdminReserved";
import AdminApiKeys from "@/pages/AdminApiKeys";
import AdminDeadLinks from "@/pages/AdminDeadLinks";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Cookies from "@/pages/Cookies";
import DPA from "@/pages/DPA";

function AppRoutes() {
    const location = useLocation();
    // Emergent OAuth callback: session_id in hash — process synchronously during render
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/about" element={<About />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/dpa" element={<DPA />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/link/:id" element={<LinkDetail />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/reserved" element={<AdminReserved />} />
            <Route path="/admin/api-keys" element={<AdminApiKeys />} />
            <Route path="/admin/dead-links" element={<AdminDeadLinks />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/:slug" element={<Redirector />} />
        </Routes>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <AppRoutes />
                    <CookieConsent />
                    <Toaster richColors position="top-right" />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
